<template>
  <div>
    <div
      v-if="duration"
      class="progress-container w-100 progress"
    >
      <div
        class="progress-bar bg-cr-red"
        :class="{'progress-bar-active': show}"
        :style="{transition: `all linear ${duration}s`}"
      ></div>
    </div>

    <transition name="fade">
      <img
        :src="source"
        v-if="show"
        class="img-fluid"
        alt="image"
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Image',
  props: {
    source: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showImage() {
      this.show = true;
      setTimeout(this.hideImage, this.duration * 1000);
    },
    hideImage() {
      this.$emit('finished');
    },
  },
  created() {
    setTimeout(this.showImage, 10);
  },
};
</script>

<style scoped>
.progress-container {
  z-index: 1051;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: #000;
}

.progress-bar {
  width: 0;
}

.progress-bar-active {
  width: 100%;
}

.img-fluid {
  max-height: 100vh;
}
</style>
